export enum DemandPlanEventType {
  Trimmed = "trimmed",
  Untrimmed = "untrimmed",
  DemandAdjusted = "demandAdjusted",
  PublishedDemandPlan = "publishedDemandPlan",
}
